@import 'abstract/colors';

sidebar-form {
.popup-login {
  &-title {
    font-weight: 700;
    text-align: center;
    font-size: 24px;
    margin: 0 0 14px;
  }

  &-forgot {
    width: 100%;
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    background: transparent;
    color: $default-orange;
    border: none;

    &:hover {
      cursor: pointer;
    }

    &.back:before {
      content: "\f30a";
      font-family: 'icomoon';
      font-weight: 400;
      margin-right: 5px;
    }
  }
}

}
